import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { EventData } from '../providers/event';

@Pipe({
    name: 'comercialSampleInfo'
})

export class ComercialSampleInfoDataPipe implements PipeTransform {

    constructor(
        private eventData: EventData
    ) { }

    transform(entityId: string, clientId: string, eventId): Observable<any> {
        if (eventId) {
            return this.eventData.getComercialSampleEvent(clientId, entityId, eventId);
        }
        else {
            return this.eventData.getComercialClient(clientId, entityId);
        }
    }
}


// WEBPACK FOOTER //
// ./src/pipes/comercialSampleInfo.ts